import {
  put, takeEvery,
} from 'redux-saga/effects';
import {
  ACT_COUNTRIES_FETCH_INIT,
  ACT_COUNTRIES_ADD_INIT,
  ACT_COUNTRIES_DELETE_INIT,
} from '../constants/actions';
import {
  fetchCountriesSuccessAction,
  addCountrySuccessAction,
  deleteCountrySuccessAction,
  addCountryFailAction,
} from '../actions';
import Api from '../services/Api';

function* fetchCountries() {
  const { data, status } = yield Api.get('types/countries?per_page=200', false);
  if (status === 200) {
    yield put(fetchCountriesSuccessAction(data.data));
  }
}

function* createCountry(action) {
  const { data, status, message } = yield Api.post('types/countries', {
    name: action.payload.name,
    code: action.payload.code,
  });
  if (status === 201) {
    yield put(addCountrySuccessAction(data));
  } else {
    yield put(addCountryFailAction(message));
  }
}

function* deleteCountry(action) {
  const { status } = yield Api.post(`types/countries/${action.payload}`);
  if (status === 204) {
    yield put(deleteCountrySuccessAction());
  }
}

export default function* countriesSagas() {
  yield takeEvery(ACT_COUNTRIES_FETCH_INIT, fetchCountries);
  yield takeEvery(ACT_COUNTRIES_ADD_INIT, createCountry);
  yield takeEvery(ACT_COUNTRIES_DELETE_INIT, deleteCountry);
}
